import { CSSProperties, memo } from "react";
import spriteSheetUrl from "../../sprite-sheet.png";
import { CELL_SIZE, RENDER_SCALE, SHEET_HEIGHT, SHEET_WIDTH } from "./spriteData";

interface SpriteCellProps {
  row: number;
  col: number;
  scale?: number;
  mirror?: boolean;
  className?: string;
  style?: CSSProperties;
}

export const SpriteCell = memo(function SpriteCell({
  row,
  col,
  scale = RENDER_SCALE,
  mirror = false,
  className,
  style,
}: SpriteCellProps) {
  const size = CELL_SIZE * scale;

  const cellStyle: CSSProperties = {
    width: size,
    height: size,
    backgroundImage: `url(${spriteSheetUrl})`,
    backgroundPosition: `-${col * size}px -${row * size}px`,
    backgroundSize: `${SHEET_WIDTH * scale}px ${SHEET_HEIGHT * scale}px`,
    backgroundRepeat: "no-repeat",
    imageRendering: "pixelated",
    transform: mirror ? "scaleX(-1)" : undefined,
    position: "absolute",
    ...style,
  };

  return <div className={className} style={cellStyle} />;
});
